import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LiveAgentSupportService } from '../../header/live-agent-support/live-agent-support.service';
import { LocationService } from '../../shared/location.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { TranslationService } from '../../shared/translation.service';

export enum LiveChatElementId {
  ONLINE = 'contact-us-chat-online',
  OFFLINE = 'contact-us-chat-offline',
}
@Component({
  selector: 'lp2-contact-us-links',
  templateUrl: './contact-us-links.component.html',
  styleUrls: ['./contact-us-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsLinksComponent implements OnInit {
  phoneNumber$ = new BehaviorSubject<String>('');
  isWritingFeedbackButtonEnabled = false;

  constructor(
    private locationService: LocationService,
    private liveAgentSupportService: LiveAgentSupportService,
    private personService: OeAppPersonService,
    translationService: TranslationService
  ) {
    const currentLanguage = translationService.getCurrentLanguage();
  }

  ngOnInit() {
    this.locationService.getContactPhone().subscribe((supportNumber) => {
      this.phoneNumber$.next(supportNumber);
    });

    this.toggleWritingFeedback();
  }

  enterLiveChat() {
    this.liveAgentSupportService.startChat();
  }

  toggleWritingFeedback() {
    this.isWritingFeedbackButtonEnabled = this.personService.isB2bStudent();
  }
}



// WEBPACK FOOTER //
// ./ts/app/contact-us/contact-us-links/contact-us-links.component.ts